import { Box, FormControlLabel, Stack, Switch, TextField, Typography } from '@mui/material';
import React from 'react';
import { useBuilder } from './ContactCaptureBuilderContext';

export const ContactCaptureCopySection = () => {
  const { busy, getValidationError, settings, type, updateContent } = useBuilder();

  return (
    <Stack spacing={2.5}>
      <TextField
        disabled={busy}
        label="Brand name"
        value={settings.content.brandName}
        onChange={event => updateContent('brandName', event.target.value)}
        fullWidth
      />
      <Stack direction="row" spacing={2} alignItems="flex-start">
        <TextField
          disabled={busy}
          label="Header text"
          value={settings.content.headerText}
          onChange={event => updateContent('headerText', event.target.value)}
          error={Boolean(getValidationError('Header text'))}
          helperText={getValidationError('Header text')?.message}
          required
          fullWidth
        />
        {type === 'inline' && (
          <FormControlLabel
            sx={{ flexShrink: 0, mt: 1 }}
            control={(
              <Switch
                disabled={busy}
                checked={settings.content.showTitle}
                onChange={event => updateContent('showTitle', event.target.checked)}
              />
            )}
            label="Show title section"
          />
        )}
      </Stack>
      <TextField
        disabled={busy}
        label="Description"
        value={settings.content.bodyText}
        onChange={event => updateContent('bodyText', event.target.value)}
        multiline
        minRows={2}
        fullWidth
      />
      <TextField
        disabled={busy}
        label="Button text"
        value={settings.content.buttonText}
        onChange={event => updateContent('buttonText', event.target.value)}
        error={Boolean(getValidationError('Button text'))}
        helperText={getValidationError('Button text')?.message}
        required
        fullWidth
      />
      {/* Only the popup offers a decline button; the embedded form has nothing to dismiss. */}
      {type === 'popup' && (
        <TextField
          disabled={busy}
          label="Decline text"
          value={settings.content.declineText}
          onChange={event => updateContent('declineText', event.target.value)}
          fullWidth
        />
      )}
      <Box>
        <Typography variant="subtitle2" fontWeight="fontWeightSemiBold">After a successful submission</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          The form is replaced by this message after the contact is saved successfully.
        </Typography>
        <TextField
          disabled={busy}
          label="Success message"
          value={settings.content.successMessage}
          onChange={event => updateContent('successMessage', event.target.value)}
          error={Boolean(getValidationError('Success message'))}
          helperText={getValidationError('Success message')?.message ||
            'Preview it using the Success view on the right.'}
          multiline
          minRows={2}
          required
          fullWidth
        />
      </Box>
    </Stack>
  );
};
